module.exports = __webpack_public_path__ + "img/visual-a-lg.d446cda5.png";